import { render, staticRenderFns } from "./SettingsSliderIcon.vue?vue&type=template&id=1dd618b2&scoped=true&"
import script from "./SettingsSliderIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsSliderIcon.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSliderIcon.vue?vue&type=style&index=0&id=1dd618b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd618b2",
  null
  
)

export default component.exports